module.exports = __webpack_public_path__ + "assets/img/home-box1-bg-light.4061059e.png";